import { fetchCities } from 'application/store/reducers/Statistics/ActionCreators';
import { SupportedCountriesDto } from '../types/countries';
import { useAppDispatch, useAppSelector } from './redux';
import { useMemo } from 'react';

/**
 * Custom hook to manage statistic filters.
 *
 * @returns An object with two properties:
 *  - `fetchCities`: a function that fetches cities based on supported countries
 *  - `cities`: an array of valid cities (cities with a non-empty city property)
 */
export const useStatisticFilters = () => {
  const dispatch = useAppDispatch();

  const { cities } = useAppSelector((state) => state.statistics);
  const validCities = useMemo(
    () => cities.filter((city) => !!city.city),
    [cities],
  );

  const fetchCitiesByCounties = async (
    supportedCountries: SupportedCountriesDto[],
  ) => {
    const searchParams = {
      ...(supportedCountries.length
        ? {
            supportedCountriesIso: supportedCountries.map((item) => item.code),
          }
        : {}),
    };

    dispatch(fetchCities(searchParams));
  };
  return {
    fetchCities: fetchCitiesByCounties,
    cities: validCities,
  };
};
